<div class="account-type-container" *ngIf="userBilling">
  <div class="account-type-header">
    <h3 class="account-type-title">
      {{'user_billing.account_type.title' | translate:{account_type: userBilling.accountLevel ? userBilling.accountLevel : '-'} }}
      <ng-container *ngIf="isAccountInactive"> - {{'user_billing.account_type.inactive' | translate}}</ng-container>
      <ng-container *ngIf="isFutureAccount"> - {{'user_billing.account_type.activates_on' | translate}} {{userBilling?.startDate | date:'MMM dd, yyyy'}}</ng-container>
      <div *ngIf="shouldReloadPage" class="reload-warning">
        {{'user_billing.account_type.reload-warning.part_1' | translate}}
        <a (click)="reloadPage()">{{'user_billing.account_type.reload-warning.link' | translate}}</a>
        {{'user_billing.account_type.reload-warning.part_2' | translate}}
      </div>
    </h3>
    <div class="trial-info" *ngIf="userBilling.dayTrialLeft > 0">
      <span>{{'user_billing.account_type.day_trial_left' | translate:{dayLeft: userBilling.dayTrialLeft} }}</span>
    </div>
  </div>
  <div></div>
  <div class="account-type-block">
    <div class="account-type-item">
      <span class="at-title">{{'user_billing.account_type.managed_influencers' | translate}}</span>
      <div class="at-value">-</div>
    </div>
    <div class="account-type-item">
      <span class="at-title">{{'user_billing.account_type.activated_influencers' | translate}}</span>
      <div class="at-value" *ngIf="!userBilling.isLoading">
        <span class="highlight-value">{{userBilling.activatedInfluencers | userUsagePipe}}</span>/{{userBilling.maxActivatedInfluencers | userUsagePipe}}
      </div>
      <div class="at-value loading" *ngIf="userBilling.isLoading">
        <achoo-loader [textPlaceholder]="true"></achoo-loader>/<achoo-loader [textPlaceholder]="true"></achoo-loader>
      </div>
    </div>
    <div class="account-type-button" *ngIf="canEditSubscription">
      <button *ngIf="!hasValidSubscription" class="button checkout-btn" (click)="checkoutSubscription()">{{'user_billing.checkout_subscription' | translate}}</button>
      <button *ngIf="hasValidSubscription" class="button manage-subscription" (click)="openCustomerPortal()">{{'user_billing.manage_subscription' | translate}}</button>
    </div>
  </div>
  <div class="account-type-block">
    <div class="account-type-item">
      <span class="at-title">{{'user_billing.account_type.contract_renewal' | translate}}</span>
      <div class="at-value" *ngIf="!userBilling.isLoading">
        <span *ngIf="userBilling.contractRenewalDate" class="highlight-value">
          {{userBilling.contractRenewalDate | date:'dd/MM/yyyy' }}
        </span>
        <span *ngIf="!userBilling.contractRenewalDate" class="highlight-value">-</span>
      </div>
      <div class="at-value loading" *ngIf="userBilling.isLoading">
        <achoo-loader [textPlaceholder]="true"></achoo-loader>
      </div>
    </div>
    <div class="account-type-item">
      <span class="at-title">{{'user_billing.account_type.next_invoice' | translate}}</span>
      <div class="at-value" *ngIf="!userBilling.isLoading">
        <span *ngIf="canShowInvoicedNextMonth" class="highlight-value">
          {{userBilling.invoicedNextMonth | currencySymbolismFormatting:0:getCurrencySymbol(userBilling.currency)}}
        </span>
        <span *ngIf="!canShowInvoicedNextMonth" class="highlight-value">-</span>
      </div>
      <div class="at-value loading" *ngIf="userBilling.isLoading">
        <achoo-loader [textPlaceholder]="true"></achoo-loader>
      </div>
    </div>
  </div>
  <div class="account-type-block" *ngIf="canViewSubscriptionId">
    <div class="account-type-item">
      <span class="at-title">{{'user_billing.account_type.customer_id' | translate}}</span>
      <div class="at-value">
        <span *ngIf="userBilling.customerId" class="highlight-value">
          {{ userBilling.customerId }}
        </span>
        <span *ngIf="!userBilling.customerId" class="highlight-value">-</span>
      </div>
      <div class="at-value loading" *ngIf="userBilling.isLoading">
        <achoo-loader [textPlaceholder]="true"></achoo-loader>
      </div>
    </div>
    <div class="account-type-item">
      <span class="at-title">{{'user_billing.account_type.subscription_id' | translate}}</span>
      <div class="at-value" *ngIf="!userBilling.isLoading">
        <span *ngIf="userBilling.subscriptionId" class="highlight-value">
          {{ userBilling.subscriptionId }}
        </span>
        <span *ngIf="!userBilling.subscriptionId" class="highlight-value">-</span>
      </div>
      <div class="at-value loading" *ngIf="userBilling.isLoading">
        <achoo-loader [textPlaceholder]="true"></achoo-loader>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/user/user-billing/account-type/account-type.component.html